<!--
 * @Author: Narcissus
 * @Date: 2022-10-26 11:09:16
 * @LastEditTime: 2022-12-28 14:32:00
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \hi-tom\src\layout\components\bottom-module\index.vue
-->
<!--  -->
<template>
  <div class="bottom_wapper">
    <p>&nbsp;</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },

  components: {},

  computed: {},

  mounted() { },

  methods: {}
}

</script>
<style scoped>
.bottom_wapper {
  width: 100%;
  font-size: 13px;
  color: #6f7579;
  background-color: #353c41;
  padding: 10px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/bottom-module/index.vue